/* Keep keyboard bypass independent of legacy hash-link handlers. */
(function () {
  var skip = document.querySelector('.ww-skip-link');
  var main = document.getElementById('ww-main-content');
  if (!skip || !main) return;
  skip.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    main.focus({ preventScroll: true });
    main.scrollIntoView({ block: 'start' });
  });
}());
